/**
 * The duration of the day in milliseconds.
 */
export var MS_PER_DAY = 86400000;



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-date-math/dist/es/ms-per-day.js
// module id = 335
// module chunks = 93